import { unknownEntries, isUnknownArray } from "../types/data";
// Firestore rejects a complete write when `undefined` appears at any depth.
// Activity metadata is assembled by many features, so all of it passes
// through this single normalizer before reaching a transaction or batch.
export const sanitizeActivityMetadata = (value: Record<string, unknown> = {}): Record<string, unknown> => {
  const sanitizeValue = (item: unknown): unknown => {
    if (item === undefined) return undefined;
    if (isUnknownArray(item)) {
      return item
        .map(sanitizeValue)
        .filter((entry) => entry !== undefined);
    }
    if (item && typeof item === "object") {
      const prototype: unknown = Object.getPrototypeOf(item);
      if (prototype === Object.prototype || prototype === null) {
        return Object.fromEntries(
          unknownEntries(item)
            .map(([key, entry]) => [key, sanitizeValue(entry)])
            .filter(([, entry]) => entry !== undefined)
        );
      }
    }
    return item;
  };

  const normalized = sanitizeValue(value);
  return normalized && typeof normalized === "object" ? normalized as Record<string, unknown> : {};
};
